import { Observable } from 'rxjs';
import { AccessControl, BatchRemovePayload, BatchAssignPayload, BatchAssignRoleResponse, PaginatedAccessControl, UserRoleResponce, CreateRoleDto, UpdateRoleDto } from './access-control.model';

export abstract class AccessControlService {
    abstract getRoles(): Observable<AccessControl[]>;
    abstract getRole(id: string): Observable<AccessControl>;
    abstract getRoleUsers(id: string): Observable<UserRoleResponce>;
    abstract createRole(payload: CreateRoleDto): Observable<AccessControl>;
    abstract updateRole(payload: UpdateRoleDto, roleId: string): Observable<AccessControl>;
    abstract deleteAccess(id: string): Observable<any>;
    abstract assignRoles(assign: BatchAssignPayload): Observable<BatchAssignRoleResponse>;
    abstract removeRoles(removals: BatchRemovePayload): Observable<BatchAssignRoleResponse>;
    abstract assignRole(roleId: string, userId: string): Observable<any>;
    abstract getUserRole(roleId: string): Observable<AccessControl[]>;
    abstract searchRoles(searchTerm: string, page?: number, limit?: number): Observable<PaginatedAccessControl>;
}
